import toast from 'react-hot-toast';
import { GET } from "../../../API/get";
import { commonSwal } from '../../../components/swalAlert/swalAlert';

export const loadData = async ({page_number, search_value, dispatch, filer, sort_key, sort_direction, start_date, end_date}) => {
    dispatch({ type: "IS_LOADING" });

    let search = search_value || '';

    let URL = `cancel/job/list/${page_number}?search=${search}`;

    if(filer === 1){
        URL = URL+`&type=1`
    }

    if(filer === 2){
        URL = URL+`&type=2`
    }

    if(start_date && end_date) {
        URL += `&start_date=${start_date}&end_date=${end_date}`;
    }

    if (sort_key && sort_direction) {
        URL += `&sort_key=${sort_key}&sort_direction=${sort_direction}`;
    }

    let response = await GET(URL);

    if(response.status === "Success"){
        dispatch({ 
            type: "IS_LOADED", 
            total_jobs: response.total_jobs, 
            total_pages: response.total_pages, 
            jobs_list: response.list, 
            current_page: page_number 
        });
    }
}

export const isReview = (job_id, page_number, dispatch) => {
    commonSwal({
        notificationType: 'REVIEW_CANCEL_JOB',
        preConfirm: async () => {
            let response = await GET(`cancel/job/review/${job_id}`);
            return response;
        },
        isConfirmed: (result) => {
            if (result.isConfirmed) {
                if(result.value.status === "Success"){
                    toast.success(result.value.message);
                    loadData({page_number, dispatch});
                } else {
                    toast.error(result.value.message);
                }
            }
        }
    })
}

export const filterDate = (data, reset, dispatch) => {
    if(data.start_date === '' && data.end_date === ''){
        dispatch({
            type: "SET_ERROR",
            error: 'Please select start date and end date.'
        });
    }else{
        if(data.start_date === ''){
            dispatch({
                type: "SET_ERROR",
                error: 'Please select start date.'
            });
        }else{
            if(data.end_date === ''){
                dispatch({
                    type: "SET_ERROR",
                    error: 'Please select end date.'
                });
            }else{
                dispatch({
                    type: "SET_ERROR",
                    error: null
                });
                reset();
                dispatch({
                    type: 'SET_DATE_RANGE',
                    start_date: data.start_date,
                    end_date: data.end_date
                });
            }
        }
    }
}